export const createRSFS_ModalState = (set, get) => ({

    isModalNowOpen: false,
    wasModalOpened: false,


    setRSFSModalState: (state) => set({
        isModalNowOpen: state.isModalOpen,
        wasModalOpened: state.wasModalOpened
    }),


    resetRSFSModalState: () => set({
        isModalNowOpen: false,
        wasModalOpened: false
    })
});



// WEBPACK FOOTER //
// ./src/store/slices/FS/RSFSModalState.js